export default __webpack_public_path__ + "static/media/view.f9c3c8be.svg";